import axios from '@/utils/request'
const urlPrefix = 'oauth'

export function updateUserInfo (params) {
  return axios({
    url: urlPrefix + '/userDetails/update/self/info',
    method: 'PUT',
    data: params
  })
}

export function updatePhone (params) {
  return axios({
    url: urlPrefix + '/userDetails/update/mobilePhone',
    method: 'POST',
    data: params
  })
}

// 验证验证码(修改手机号)
export function validateCode (params) {
  return axios({
    url: urlPrefix + '/userDetails/existByPone',
    method: 'GET',
    params: params
  })
}

// 验证验证码(修改密码)
export function validateCodeByPsd (params) {
  return axios({
    url: '/platform/publics/check/code',
    method: 'GET',
    params: params
  })
}

// 修改密码
export function changePsd (params) {
  return axios({
    url: urlPrefix + '/userDetails/reset/password',
    method: 'PUT',
    data: params
  })
}
